import { render, staticRenderFns } from "./terms-of-use.vue?vue&type=template&id=138f6b1c&scoped=true&"
import script from "./terms-of-use.vue?vue&type=script&lang=js&"
export * from "./terms-of-use.vue?vue&type=script&lang=js&"
import style0 from "./terms-of-use.vue?vue&type=style&index=0&id=138f6b1c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138f6b1c",
  null
  
)

component.options.__file = "terms-of-use.vue"
export default component.exports